import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Both children redirect into `/$slug/apps/omniscient`, so this layout renders
 * nothing and gates nothing: the app's own entitlement decides who may open it,
 * and warming the org's assignee lookups for a route nobody stays on would pull
 * four org-wide lists on the way out.
 */
export const Route = createFileRoute('/$slug/omniscient')({
  component: Outlet
});
